<template>
  <div>
    <empty-reminder v-if="records.length === 0 && !loading"></empty-reminder>

    <div>
      <div class="records" v-for="record in records">
        <p class="description">
          {{ $t('yourFriends') }} {{ record.nickname }} {{ $t('bought') }}
          {{ record.package_device_count }} {{ $tc('devices', record.package_device_count)}}
          {{ $t(record.package_name) }}{{ $t('plan') }}
          <template v-if="record.status === 'cancelled'"><span>{{ $t('refunded') }}</span></template>
        </p>
        <p class="type">
          {{ $t('type') }}: <span>{{ record.first_purchase ? $t('firstTopup') : $t('renew') }}</span>
        </p>
        <p class="amount">
          {{ $t('amount') }}: <span :class="{'on-hold': awardOnHold(record.status)}">{{ $t(currentSymbol) }} {{ record[currentSymbol] }}</span>
        </p>
        <p class="status">
          {{ $t('status') }}: <span :class="{'on-hold': awardOnHold(record.status)}">{{ $t(record.status) }}</span>
        </p>
      </div>
    </div>

    <spinner :show="loading" class="spinner-component"></spinner>
    <back-to-top></back-to-top>
    <load-more :current-page="currentPage" :total-page="totalPage" :loading="loading" @click.native="getAwardRecords"></load-more>
  </div>
</template>

<script>
  import EmptyReminder from '../EmptyReminder.vue'
  import locales from './lang'
  import Spinner from '../../Spinner.vue'
  import BackToTop from '../../backToTop/BackToTop.vue'
  import LoadMore from '../../loadMore/LoadMore.vue'

  export default {
    name: 'reward-record-m',
    components: {EmptyReminder, Spinner, BackToTop, LoadMore},
    props: ['initAwardRecords'],
    data: function () {
      return {
        records: [],
        loading: false,
        currentPage: 0,
        totalPage: 1
      }
    },
    locales,
    watch: {
      initAwardRecords() {
        this.records = this.records.concat(this.initAwardRecords.data)
        this.totalPage = Math.ceil(this.initAwardRecords.meta['total'] / this.initAwardRecords.meta['per_page'])
        this.currentPage = this.initAwardRecords.meta['current_page']
      }
    },
    computed: {
      currentSymbol() {
        return this.$store.state.currentSymbol
      }
    },
    methods: {
      getAwardRecords() {
        if (this.currentPage > this.totalPage) {
          return
        }
        this.loading = true
        this.currentPage++
        this.$http.get('api/commission-records?type=internal-award', {params: {'page': this.currentPage}}).then(response => {
          this.loading = false
          this.records = this.records.concat(response.data.data)
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
        }, response => {
          this.loading = false
        })
      },
      awardOnHold(status) {
        return status === 'pending' || status === 'cancelled'
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .records {
    padding: .16rem 0;
    &:not(:last-child) {
      border-bottom: 1px solid #E0D7E3;
    }
  }

  p {
    font-size: .14rem;
    color: #333;
    letter-spacing: 0;
    line-height: .2rem;
    &:nth-child(n+2) {
      margin-top: .12rem;
    }
  }

  .spinner-component {
    margin: 0 auto .1rem auto;
  }
</style>




// WEBPACK FOOTER //
// RewardRecordsM.vue?2d46eab0